function dragElement(elmnt) {
  if (!elmnt) return;

  // Los paneles de ToolContainer mueven su puesto independiente. Los paneles
  // ajenos al contenedor conservan el comportamiento histórico de top/left.
  if (elmnt.classList.contains("tool-panel--docked")) {
    dragDockedElement(elmnt);
    return;
  }

  let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
  if (document.getElementById(elmnt.id + "header")) {
    // if present, the header is where you move the DIV from:
    document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
  } else {
    // otherwise, move the DIV from anywhere inside the DIV:
    elmnt.onmousedown = dragMouseDown;
  }

  function dragMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
    // get the mouse cursor position at startup:
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onmousemove = elementDrag;
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    // calculate the new cursor position:
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    // set the element's new position:
    elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
    elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
  }

  function closeDragElement() {
    // stop moving when mouse button is released:
    document.onmouseup = null;
    document.onmousemove = null;
  }
}

function dragDockedElement(elmnt) {
  const header = document.getElementById(elmnt.id + "header") || elmnt;
  const slot = elmnt.closest(".tool-slot");
  let startClientX = 0;
  let startClientY = 0;
  let startLeft = 0;
  let startTop = 0;
  let currentLeft = 0;
  let currentTop = 0;
  let startRect = null;
  let boundsRect = null;

  header.onmousedown = dragMouseDown;

  function dragMouseDown(e) {
    // Los controles del encabezado deben conservar su click normal.
    if (e.target.closest("button, a, input, select, textarea, label")) return;

    e = e || window.event;
    e.preventDefault();
    startClientX = e.clientX;
    startClientY = e.clientY;
    startRect = (slot || elmnt).getBoundingClientRect();
    const layout = elmnt.closest(".tool-layout");
    boundsRect = layout ? layout.getBoundingClientRect() : {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0,
    };
    startLeft = startRect.left - boundsRect.left;
    startTop = startRect.top - boundsRect.top;
    currentLeft = startLeft;
    currentTop = startTop;

    document.onmouseup = closeDragElement;
    document.onmousemove = elementDrag;
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();

    const margin = 8;
    const deltaX = Math.max(
      boundsRect.left + margin - startRect.left,
      Math.min(e.clientX - startClientX, boundsRect.right - margin - startRect.right)
    );
    const deltaY = Math.max(
      boundsRect.top + margin - startRect.top,
      Math.min(e.clientY - startClientY, boundsRect.bottom - margin - startRect.bottom)
    );
    currentLeft = startLeft + deltaX;
    currentTop = startTop + deltaY;

    const target = slot || elmnt;
    target.style.left = `${currentLeft}px`;
    target.style.top = `${currentTop}px`;
  }

  function closeDragElement() {
    document.onmouseup = null;
    document.onmousemove = null;

    if (slot && startRect) {
      const event = new CustomEvent("map-tool-position-change", {
        bubbles: true,
        detail: {
          id: slot.dataset.toolId,
          left: currentLeft,
          top: currentTop,
        },
      });
      slot.dispatchEvent(event);
    }

    startRect = null;
    boundsRect = null;
  }
}

export const draggableDiv = {
    data() {
        return {
            message: 'Hola'
        }
    },
    methods: {
      makeDraggable: function (id) {
        dragElement(document.getElementById(id));
      }
    }
  }
